<!-- add payment method / add payment type dialog -->
<p-dialog [modal]="true"
          [focusOnShow]="false"
          [(visible)]="addPaymentDialog.visible"
          [style]="{width: '50rem'}"
          [closable]="false"
          [resizable]="false"
          [draggable]="false"
          styleClass="custom-header-dialog">
  <ng-template #header>
    <div>
      <span class="p-dialog-title">{{ i18n?.i18nLng()[addPaymentDialog?.i18nTitleKey] }}</span>
    </div>
    <p-button icon="pi pi-times"
              [text]="true"
              [rounded]="true"
              styleClass="p-dialog-close-button"
              severity="secondary"
              [attr.aria-label]="i18n.i18nLng()['CLOSE']"
              (click)="cancelAddPaymentData()"/>
  </ng-template>
  @if (addPaymentDialog.visible) {
    @switch (addPaymentDialog.type) {
      @case (PaymentDialogType.MAIN) {
        <add-form-payment-category [paymentData]="newPaymentData" [paymentInvalidFlags]="paymentInvalidFlags" (ibanValidated)="onIbanValidated($event)"></add-form-payment-category>
      }
      <!-- until other components are needed for specific payment methods, there is only one add-payment component -->
      @default {
        <add-form-payment [paymentData]="newPaymentData" [paymentInvalidFlags]="paymentInvalidFlags" [customerGroup]="authService.organisationData.customerGroup" (ibanValidated)="onIbanValidated($event)"></add-form-payment>
      }
    }
  }
  <ng-template #footer class="pt-3">
    <div class="flex w-full align-items-center justify-content-between">
      <div class="text-sm">
        <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
      </div>
      <div class="flex gap-2">
        <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelAddPaymentData()"/>
        <p-button [label]="i18n.i18nLng()['SAVE']" (onClick)="saveNewPaymentData()" [disabled]="addPaymentInProgress"/>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- request payment types activation dialog -->
<p-dialog [modal]="true"
          [focusOnShow]="true"
          [(visible)]="enablePaymentTypesDialog"
          [style]="{width: '34rem'}"
          [closable]="false"
          [resizable]="false"
          [draggable]="false"
          [closeOnEscape]="false"
          styleClass="custom-header-dialog">
  <ng-template #header>
    <div>
      <span class="p-dialog-title">{{ i18n?.i18nLng()['ENABLEPAYMENTTYPESTITLE'] }}</span>
    </div>
    <p-button icon="pi pi-times"
              [text]="true"
              [rounded]="true"
              styleClass="p-dialog-close-button"
              severity="secondary"
              [attr.aria-label]="i18n.i18nLng()['CLOSE']"
              (click)="cancelEnablePaymentTypes()"/>
  </ng-template>
  <div class="flex flex-column gap-2 w-full">
    <label for="paymenttypelist">
      {{ i18n.i18nLng()['ENABLEPAYMENTTYPESSUBTITLE'] }}
    </label>
    <p-listbox id="paymenttypelist"
               name="paymenttypelist"
               [(ngModel)]="paymentTypesToActivate"
               [options]="inactivePaymentTypesList"
               [multiple]="true"
               [checkbox]="true"
               [group]="true"
               [filter]="true"
               [filterPlaceHolder]="i18n.i18nLng()['SEARCHBY'] + ' ' + i18n.i18nLng()['PAYMENTTYPE']"
               [ariaFilterLabel]="i18n.i18nLng()['SEARCHBY'] + ' ' + i18n.i18nLng()['PAYMENTTYPE']"
               [showToggleAll]="false"
               scrollHeight="16rem"
               [ariaLabel]="i18n.i18nLng()['ENABLEPAYMENTTYPESINFO']"
               optionLabel="label"
               optionValue="value"
               class="w-full">
      <ng-template let-group #group>
        <div class="flex align-items-center gap-2 overflow-hidden">
          @if (!group.customIcon) {
            <i class="icon large-icon-cell" [ngClass]="group.icon"></i>
          } @else {
            <sps-custom-icon [name]="group.icon" [size]="21"></sps-custom-icon>
          }
          <div class="picklist-item-label">{{ group.label }}</div>
        </div>
      </ng-template>
    </p-listbox>
  </div>
  <ng-template #footer class="pt-3">
    <div class="flex gap-2">
      <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelEnablePaymentTypes()"/>
      <p-button [label]="i18n.i18nLng()['ENABLEBUTTON']" (onClick)="requestEnablePaymentTypes()" [disabled]="paymentTypesToActivate.length === 0"/>
    </div>
  </ng-template>
</p-dialog>

<!-- Content -->
@if (!loading) {
  <div class="grid">
    <div class="col-12 xl:col-9 lg:col-8">
      <div class="grid">
        @for (paymentMethod of paymentDataService.paymentMethods; track paymentMethod) {
          @if (paymentMethod.hasPaymentTypes) {
            <div class="col-12 xl:col-4">
              <p-card class="h-full" [id]="paymentMethod.name">
                <ng-template pTemplate="title">
                  <div class="flex flex-1 align-items-center gap-2">
                    <div class="flex-1">{{ i18n?.i18nLng()[paymentMethod.name] }}</div>
                    <p-button icon="pi pi-plus-circle"
                              severity="secondary"
                              [label]="i18n?.i18nLng()['NEW']"
                              [ariaLabel]="i18n?.i18nLng()['ADDPAYMENTTYPE']"
                              (click)="addPaymentMethod(paymentMethod)"
                              [disabled]="paymentMethod.lockedByAdmin || paymentMethod.lockedByTenant"/>
                  </div>
                </ng-template>
                <div class="payment-list">
                  @for (item of (paymentDataService.paymentTypes | subPaymentItems : paymentMethod.name); track item.id) {
                    <sps-payment-type-list-item [paymentListItem]="item"
                                           (itemClicked)="onPaymentTypeClick($event)">
                    </sps-payment-type-list-item>
                  }
                </div>
              </p-card>
            </div>
          }
        }
      </div>
    </div>
    <div class="col-12 xl:col-3 lg:col-4">
      <div class="grid">
        <div class="col-12">
          <p-card [header]="i18n?.i18nLng()['ADDNEWPAYMENTMETHOD']" class="card-secondary">
            <div class="line-height-3">
              {{ i18n.i18nLng()['ADDMETHODINFO'] }}
            </div>
            <ng-template pTemplate="footer">
              <p-button icon="pi pi-plus-circle" [label]="i18n?.i18nLng()['ADDMETHODBUTTON']" variant="outlined" (click)="addPaymentMethod(null, true)"/>
            </ng-template>
          </p-card>
        </div>
        <div class="col-12">
          <p-card [header]="i18n?.i18nLng()['ENABLENEWPAYMENTTYPES']" class="card-secondary">
            <div class="line-height-3">
              {{ i18n.i18nLng()['ENABLEPAYMENTTYPESINFO'] }}
            </div>
            <ng-template pTemplate="footer">
              <p-button icon="pi pi-check-circle" [label]="i18n?.i18nLng()['ENABLEPAYMENTTYPESBUTTON']" variant="outlined" (click)="enablePaymentTypes()"/>
            </ng-template>
          </p-card>
        </div>
      </div>
    </div>
  </div>
}
